export const calculateDiscountedPrice = (
  originalPrice: number,
  discountType: "rate" | "amount",
  discountRate?: number,
  discountAmount?: number,
) => {
  if (discountType === "rate") {
    return Math.max(0, Math.floor(originalPrice * (1 - (discountRate ?? 0) / 100)));
  }
  return Math.max(0, originalPrice - (discountAmount ?? 0));
};
